// extracted by mini-css-extract-plugin
module.exports = {"Loader":"ButtonSpinner_Loader__1Hgvx","load1":"ButtonSpinner_load1__3I0CF"};